/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
 */

import React, { Component } from 'react';
class TableRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null
    };
  }
  togglePopup(testName, keyName, index) {
    this.setState({
      selectedRow: index
    });
    this.props.togglePopupVal(testName, keyName);
  }
  componentWillReceiveProps() {
    if (this.props.showPopup) {
      this.setState({
        selectedRow: null
      });
    }
  }
  render() {
    let testName = this.props.results.name;
    let lastModifiedDate = this.props.results.lastModifiedDate;
    let createdOn = this.props.results.createdOn;
    let keyName = this.props.results.key;
    let classNameTr = 'icma-tr-tr';
    if (this.props.showPopup) {
      if (this.state.selectedRow === this.props.index) {
        classNameTr = 'icma-tr-tr dls-rp-selected';
      }
    } else {
      classNameTr = 'icma-tr-tr';
    }

    return (
      <tr
        className={classNameTr}
        onClick={this.togglePopup.bind(
          this,
          testName,
          keyName,
          this.props.index
        )}
      >
        <td className="icma-tr-td">{testName}</td>
        <td className="icma-tr-td">{createdOn}</td>
        <td className="icma-tr-td">{lastModifiedDate}</td>
      </tr>
    );
  }
}

export default TableRow;
